<template>
  <div id="create_physical_card_page" class="page-wrapper">
    <section class="page-title">
      <div class="go-back" @click="goback()">
        <img
          src="@/assets/images/back-arrow-btn.svg"
          class="icon-back"
          alt="back"
        />
      </div>
      {{ lbl.value_design.create_card.physical.page_title }}
    </section>
    <section class="input-wrapper">
      <div class="input-field">
        <span class="lable-input">
          {{ lbl.value_design.create_card.physical.input_title.card_number }}
        </span>
        <a-input
          v-model="cardNumber"
          type="number"
          size="large"
          allow-clear
          :max-length="12"
          :placeholder="
            lbl.value_design.create_card.physical.input_title.placeholder
          "
        />
      </div>
      <div class="input-field">
        <span class="lable-input">
          {{ lbl.value_design.create_card.physical.input_title.pin }}
        </span>
        <a-input
          v-model="pin"
          type="number"
          size="large"
          allow-clear
          :max-length="6"
          :placeholder="
            lbl.value_design.create_card.physical.input_title.placeholder
          "
        />
      </div>
    </section>
    <div class="action-wrapper">
      <a-button
        class="submit-btn"
        :disabled="isValidate"
        @click="createPhysicalCard"
      >
        {{ lbl.value_design.create_card.physical.submit_btn }}
      </a-button>
    </div>
    <AlertCreateModal
      :show="alert.show"
      :success="alert.success"
      :title="alert.title"
      :desc="alert.desc"
      :type="'physical'"
    />
  </div>
</template>

<script>
import Account from '@/helper/AccountHelper.js'
import AlertCreateModal from '@/module/ValueDesign/components/AlertCreateModal'
import BzbsVD from '@/core/ValueDesign/BzbsValueDesign.js'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
export default {
  name: 'CreatePhysicalCard',
  components: {
    AlertCreateModal,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      cardNumber: null,
      pin: null,
      alert: {
        show: false,
        success: false,
        title: '',
        desc: '',
      },
    }
  },
  computed: {
    isValidate() {
      return !this.cardNumber || !this.pin
    },
  },
  created() {
    Account.bzbsAnalyticTracking(
      'create_physical_card_page',
      'create_physical_card_page',
      'view_create_physical_card_page',
      'on view',
    )
    this.handleLoading(false)
    this.handleFooter(false)
    this.handleLanguage(true)
  },
  methods: {
    goback() {
      Account.bzbsAnalyticTracking(
        'create_physical_card_page',
        'create_physical_card_page',
        'click_back',
        'on click',
      )

      this.$router.push({
        name: 'createVDCard',
        query: {
          from: this.$route.query.from,
        },
      })
    },
    createPhysicalCard() {
      this.handleLoading(true)
      Account.bzbsAnalyticTracking(
        'create_physical_card_page',
        'create_physical_card_page',
        'click_continue',
        'on click',
      )
      var params = {
        cardId: this.cardNumber,
        pin: this.pin,
      }
      return new Promise(resolve => {
        BzbsVD.createPhysicalCard(params)
          .then(res => {
            this.handleLoading(false)
            if (res.data.success) {
              Account.bzbsAnalyticTracking(
                'create_physical_card_page',
                `value_design`,
                'add_card_success',
                'on view',
              )
              this.alert = {
                show: true,
                success: true,
                title: this.lbl.value_design.create_card.modal_alert
                  .success_physical_title,
                desc: this.lbl.value_design.create_card.modal_alert
                  .success_physical_desc,
              }
            } else {
              Account.bzbsAnalyticTracking(
                'create_physical_card_page',
                `value_design`,
                'add_card_fail',
                'on view',
              )
              if (res.data.message === 'Card already exist') {
                this.alert = {
                  show: true,
                  success: false,
                  title: this.lbl.value_design.create_card.modal_alert
                    .fail_exist_title,
                  desc: this.lbl.value_design.create_card.modal_alert
                    .fail_exist_desc,
                }
              } else if (res.data.message === 'Card is not found') {
                this.alert = {
                  show: true,
                  success: false,
                  title: this.lbl.value_design.create_card.modal_alert
                    .fail_not_found_title,
                  desc: this.lbl.value_design.create_card.modal_alert
                    .fail_not_found_desc,
                }
              } else {
                this.alert = {
                  show: true,
                  success: false,
                  title: res.data.message,
                  desc: null,
                }
              }
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            Account.bzbsAnalyticTracking(
              'create_physical_card_page',
              `value_design`,
              'add_card_fail',
              'on view',
            )
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            resolve(error)
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.page-wrapper {
  max-width: 820px;
  margin: auto;
  padding: 0px 20px 50px;
  .page-title {
    font-size: 28px;
    font-weight: 500;
    color: #212121;
    margin: 10px auto;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;

    .go-back {
      width: 42px;
      height: 42px;
      border-radius: 100px;
      border: 1px solid #eeeeee;
      background-color: #ffffff;
      box-shadow: 0px 4px 10px 0px #0000001a;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon-back {
        width: 16px;
      }
    }
  }
  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .input-field {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .lable-input {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #424242;
      }
    }
  }
  .action-wrapper {
    position: fixed;
    left: 0;
    bottom: 65px;
    width: 100%;
    padding: 0px 20px;
    .submit-btn {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 53px;
      padding: 16px 24px;
      border-radius: 100px;
      border-color: #f9a601;
      background: #f9a601;
      color: #ffffff;
      font-weight: 500;
    }
    .submit-btn:disabled {
      opacity: 0.5;
    }
  }
}
</style>
<style>
.ant-input {
  border-radius: 8px !important;
  font-size: 14px !important;
  height: 50px !important;
}
.ant-input:focus,
.ant-input:hover,
.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: #f9a601;
}
</style>
